import { useEffect, useState } from "react";

export default function useWindowScroll() {

   const [scrollAll, setScrollAll] = useState(false);

  useEffect(() => {
  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      setScrollAll(true)
    }else{
      setScrollAll(false)
    }
  };

  window.addEventListener('scroll', handleScroll);

  return () => {
    window.removeEventListener('scroll', handleScroll);
    setScrollAll(false)
  };
  }, []);

  return scrollAll;

}